import { createSlice } from "@reduxjs/toolkit";

export const studentManagementSlice = createSlice({
  name: "studentManagement",
  initialState: {
    openStudentModal: false,
    editingStudent: null,
    students: [],
    activeInterviews: {},
    studentForm: {
      name: "",
      email: "",
      phone_number: "",
      address: "",
      university: "",
      course: "",
      graduation_year: 2024,
      gpa: "",
      emergency_contact: "",
      notes: "",
    },
  },
  reducers: {
    setCreateStudentModal: (state, action) => {
      state.openStudentModal = action.payload;
      if (!action.payload) {
        state.editingStudent = null;
      }
    },
    setEditingStudent: (state, action) => {
      state.editingStudent = action.payload;
      if (action.payload) {
        state.openStudentModal = true;
        // Pre-fill form with student data
        state.studentForm = {
          name: action.payload.name || "",
          email: action.payload.email || "",
          phone_number: action.payload.phone_number || "",
          address: action.payload.address || "",
          university: action.payload.university || "",
          course: action.payload.course || "",
          graduation_year: action.payload.graduation_year || 2024,
          gpa: action.payload.gpa || "",
          emergency_contact: action.payload.emergency_contact || "",
          notes: action.payload.notes || "",
        };
      }
    },
    updateStudentFormField: (state, action) => {
      const { name, value } = action.payload;
      state.studentForm[name] = value;
    },
    resetStudentForm: (state) => {
      state.studentForm = {
        name: "",
        email: "",
        phone_number: "",
        address: "",
        university: "",
        course: "",
        graduation_year: 2024,
        gpa: "",
        emergency_contact: "",
        notes: "",
      };
    },
    addStudentToList: (state, action) => {
      state.students = [action.payload, ...state.students];
    },
    setStudentsList: (state, action) => {
      state.students = action.payload;
    },
    setActiveInterviews: (state, action) => {
      state.activeInterviews = action.payload;
    },
    updateStudentInList: (state, action) => {
      const updatedStudent = action.payload;
      const index = state.students.findIndex((s) => s.id === updatedStudent.id);
      if (index !== -1) {
        state.students[index] = { ...state.students[index], ...updatedStudent };
      }
    },
  },
});

const { actions, reducer: studentManagementReducer } = studentManagementSlice;
export const {
  setCreateStudentModal,
  setEditingStudent,
  updateStudentFormField,
  resetStudentForm,
  addStudentToList,
  setStudentsList,
  setActiveInterviews,
  updateStudentInList,
} = actions;
export default studentManagementReducer;
